import fr from 'facet-rest';
import PaymentFailedAlert
  from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/BillingDetailsProfileSubpage/PaymentFailedAlert';
import PaymentDetailsListMeta
  from 'Components/ComponentLibrary/Components/Uncategorized/PaymentDetailsList/PaymentDetailsListMeta';
import PaymentStatusTextMeta from 'Components/ComponentLibrary/Components/Uncategorized/PaymentStatusText/PaymentStatusTextMeta';
import PaymentDetailsSubtotalListMeta
  from 'Components/ComponentLibrary/Components/Uncategorized/PaymentDetailsSubtotalList/PaymentDetailsSubtotalListMeta';
import DescriptionsListMeta
  from 'Components/ComponentLibrary/Components/Uncategorized/DescriptionsList/DescriptionsListMeta';
import BillingDetailsMobileRowLineItem
  from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/BillingDetailsProfileSubpage/BillingDetailsTableMobileRow/BillingDetailsMobileRowLineItem/BillingDetailsMobileRowLineItem';
import { FDTitleText } from '@facet-wealth/design';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';

export const BillingDetailsProfileSubpageMetaOverride = fr.metaOverride()
  .overrideAll({
    readonly: true,
    _hideLabel: true,
  })
  .nameOverride('date', {
    _formatString: 'l',
  })
  .nameOverride('paymentFailed', {
    _component: () => PaymentFailedAlert,
    _spreadPropNames: ['resource'],
  },
  {
    ordinal: 200,
  })
  .nameOverride('descriptions', {
    _component: () => DescriptionsListMeta,
  }, overrideReadOnly)
  .nameOverride('paymentMethods', {
    _component: () => PaymentDetailsListMeta,
  },
  {
    ordinal: 201,
  })
  .nameOverride('subTotals', {
    _component: () => PaymentDetailsSubtotalListMeta,
  }, {
    ordinal: 202,
  })
  .nameOverride('lineItems', {
    _component: () => BillingDetailsMobileRowLineItem,
  }, overrideReadOnly)
  .nameOverride('status', {
    _component: () => PaymentStatusTextMeta,
    _spreadPropNames: ['resource'],
  },
  {
    ordinal: 203,
  })
  .nameOverride('total', {
    _component: () => FDTitleText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly);
